import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getMenuStart,
  getMenuSuccess,
  getMenuFailed,
  getSubMenuStart,
  getSubMenuSuccess,
  getSubMenuFailed,
} from "../redux/menu";

import {
  getInternalDocumentMenuAPI,
  getInternalDocumentSubMenuAPI,
} from "core/http/service/internalDocument";

import { SCREEN } from "helper/roleChecker/Screens";

function* getMenuItem() {
  try {
    const res = yield call(getInternalDocumentMenuAPI, SCREEN.IP_012);
    yield put({
      type: getMenuSuccess.type,
      payload: res.data,
    });
  } catch (error: any) {
    yield put({
      type: getMenuFailed.type,
    });
  }
}

function* getSubMenuItem(action: ReturnType<typeof getSubMenuStart>) {
  try {
    const res = yield call(getInternalDocumentSubMenuAPI, {
      screenCode: SCREEN.IP_012,
      id: action.payload.id,
    });
    yield put({
      type: getSubMenuSuccess.type,
      payload: {
        id: action.payload.id,
        data: res.data,
      },
    });
  } catch (error: any) {
    yield put({
      type: getSubMenuFailed.type,
      payload: {
        id: action.payload.id,
      },
    });
  }
}

function* watchGetMenu() {
  yield takeLatest(getMenuStart.type, getMenuItem);
}

function* watchGetSubMenu() {
  yield takeLatest(getSubMenuStart.type, getSubMenuItem);
}

export default function* getMenuSaga() {
  yield all([watchGetMenu(), watchGetSubMenu()]);
}
